export default "__VITE_ASSET__D$ZIO5lg__"